module.exports = __webpack_public_path__ + "img/bucket_parked.0c42f94e.svg";